<template>
<v-app>
<v-navigation-drawer
      v-model="drawer"
      app
      clipped
      color="#2f363e"
    >
      <v-list  dense>
        <v-list-item >
          <v-list-item-action>
            <router-link :to="{name:'Dashboard'}" color="white" style="text-decoration:none;color:white;"><v-icon>fas fa-chalkboard</v-icon></router-link>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title><router-link :to="{name:'Dashboard'}" color="white" style="text-decoration:none;color:white;">{{ $t('menu.dashboard') }}</router-link></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list  subheader>
                      <v-subheader>{{ $t('menu.negocios') }}</v-subheader>
         <v-list-group color="#393E46" v-for="negocio in mnegocios" :key="negocio.id" :prepend-icon="negocio.tipoNegocio.icono">
           <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="negocio.negocio" style="font-size:12px"></v-list-item-title>
            </v-list-item-content>
          </template>
           <v-list-group color="#393E46"  sub-group prepend-icon="fas fa-archway">
             <template v-slot:activator>
               <v-list-item-content >
                 <v-list-item-title style="font-size:12px" >Administra</v-list-item-title>
               </v-list-item-content>
             </template>
             <v-list-item  style="font-size:12px" v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  " >
          <v-list-item-action>
            <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Fiestas', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-glass-cheers</v-icon></router-link>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title ><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Fiestas', params: { idnegocio: negocio.tag }}">Fiestas</router-link></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
           <v-list-item v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  " >
          <v-list-item-action>
           <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Promotor', params: { idnegocio: negocio.tag }}"> <v-icon>fas fa-user-ninja</v-icon></router-link>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Promotor', params: { idnegocio: negocio.tag }}">{{ $t('menu.promotores') }}</router-link></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
           <v-list-item  style="font-size:12px">
          <v-list-item-action>
            <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Socios', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-user-tag</v-icon></router-link>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Socios', params: { idnegocio: negocio.tag }}">{{ $t('menu.socios') }}</router-link></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
               <v-list-item  style="font-size:12px">
                   <v-list-item-action>
                       <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Usuarios', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-user</v-icon></router-link>
                   </v-list-item-action>
                   <v-list-item-content>
                       <v-list-item-title><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Usuarios', params: { idnegocio: negocio.tag }}">Usuarios</router-link></v-list-item-title>
                   </v-list-item-content>
               </v-list-item>
               <v-list-item  style="font-size:12px">
                   <v-list-item-action>
                       <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'CodigoPuerta', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-door-open</v-icon></router-link>
                   </v-list-item-action>
                   <v-list-item-content>
                       <v-list-item-title><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'CodigoPuerta', params: { idnegocio: negocio.tag }}">Cod Puerta</router-link></v-list-item-title>
                   </v-list-item-content>
               </v-list-item>
           </v-list-group>

            <v-list-group v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  " color="#393E46" sub-group prepend-icon="fas fa-clipboard-list">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title style="font-size:12px" >{{ $t('menu.listas') }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item >
          <v-list-item-action>
            <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Listaspromo', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-user-friends</v-icon></router-link>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Listaspromo', params: { idnegocio: negocio.tag }}">{{ $t('menu.promotores') }}</router-link></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
          <v-list-item >
            <v-list-item-action>
              <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'GeneraCodigo', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-barcode</v-icon></router-link>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'GeneraCodigo', params: { idnegocio: negocio.tag }}">Generar Codigos</router-link></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
              <v-list-item >
                <v-list-item-action>
                  <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'GeneraLista', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-clipboard-list</v-icon></router-link>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'GeneraLista', params: { idnegocio: negocio.tag }}">Ingresa Lista</router-link></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
          <v-list-item v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  ">
          <v-list-item-action>
            <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Listasmarcar', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-signature</v-icon></router-link>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Listasmarcar', params: { idnegocio: negocio.tag }}">Marcar</router-link></v-list-item-title>
          </v-list-item-content>
          </v-list-item>
        </v-list-group>
            <v-list-group v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  " color="#393E46" sub-group prepend-icon="fas fa-couch">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title style="font-size:12px">Mesas / Boxes</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-if="negocio.tipoNegocio.id === 2">
          <v-list-item-action>
<router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'ReservaFiesta', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-utensils</v-icon></router-link>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'ReservaFiesta', params: { idnegocio: negocio.tag }}">{{ $t('menu.reservas') }}</router-link></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
              <v-list-item v-if="negocio.tipoNegocio.id !== 2">
                <v-list-item-action>
                  <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Separacion', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-utensils</v-icon></router-link>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Separacion', params: { idnegocio: negocio.tag }}">{{ $t('menu.reservas') }}</router-link></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
        <v-list-item v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  ">
          <v-list-item-action>
            <v-icon>fas fa-person-booth</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Mesas', params: { idnegocio: negocio.tag }}">Mesas/Boxes</router-link></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
              <v-list-item v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  ">
                <v-list-item-action>
                  <v-icon>fas fa-map</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'MapaMesas', params: { idnegocio: negocio.tag }}">Mapa Espacios</router-link></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
        <v-list-item v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  ">
          <v-list-item-action>
            <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Zonas', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-map-pin</v-icon></router-link>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Zonas', params: { idnegocio: negocio.tag }}">{{ $t('menu.zonas') }}</router-link></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </v-list-group>
            <v-list-group  color="#393E46" sub-group prepend-icon="fas fa-chart-pie">
                 <template v-slot:activator>
                     <v-list-item-content>
                         <v-list-item-title style="font-size:12px">{{ $t('menu.reportes') }}</v-list-item-title>
                     </v-list-item-content>
                 </template>
                 <v-list-item v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  ">
                     <v-list-item-action>
                         <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Puerta', params: { idnegocio: negocio.tag }}"> <v-icon>fas fa-door-open</v-icon></router-link>
                     </v-list-item-action>
                     <v-list-item-content>
                         <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Puerta', params: { idnegocio: negocio.tag }}">{{ $t('menu.puerta') }}</router-link></v-list-item-title>
                     </v-list-item-content>
                 </v-list-item>
              <v-list-item v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  ">
                <v-list-item-action>
                  <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Asistencia', params: { idnegocio: negocio.tag }}"> <v-icon>fas fa-person-booth</v-icon></router-link>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Asistencia', params: { idnegocio: negocio.tag }}">Asistencia</router-link></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
                 <v-list-item v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  ">
                     <v-list-item-action>
                       <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Cumples', params: { idnegocio: negocio.tag }}">  <v-icon>fas fa-birthday-cake</v-icon></router-link>
                     </v-list-item-action>
                     <v-list-item-content>
                       <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Cumples', params: { idnegocio: negocio.tag }}">{{ $t('menu.cumpleanos') }}</router-link></v-list-item-title>
                     </v-list-item-content>
                 </v-list-item>
              <v-list-item  v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  ">
                <v-list-item-action>
                  <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'RankingAsistencia', params: { idnegocio: negocio.tag }}">  <v-icon>fas fa-arrow-alt-circle-up</v-icon></router-link>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'RankingAsistencia', params: { idnegocio: negocio.tag }}">Ranking Asistencia</router-link></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
                 <v-list-item >
                     <v-list-item-action>
                         <v-icon>fas fa-frog</v-icon>
                     </v-list-item-action>
                     <v-list-item-content>
                         <v-list-item-title style="font-size:12px">{{ $t('menu.filtros') }}</v-list-item-title>
                     </v-list-item-content>
                 </v-list-item>
             </v-list-group>
            <v-list-group color="#393E46" sub-group prepend-icon="fas fa-cog">
                 <template v-slot:activator>
                     <v-list-item-content>
                         <v-list-item-title style="font-size:12px">{{ $t('menu.configuracion') }}</v-list-item-title>
                     </v-list-item-content>
                 </template>
              <v-list-group color="#393E46" sub-group prepend-icon="fas fa-palette">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title style="font-size:12px" >Diseños</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item >
                  <v-list-item-action>
                    <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'DisenioFormularios', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-id-card</v-icon></router-link>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'DisenioFormularios', params: { idnegocio: negocio.tag }}">Formularios</router-link></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item >
                  <v-list-item-action>
                    <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'contactocl', params: { idnegocio: negocio.tag }}"><v-icon>fas fa-address-book</v-icon></router-link>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'contactocl', params: { idnegocio: negocio.tag }}">Contactos</router-link></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
               <v-list-item v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  " >
                 <v-list-item-action>
                   <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'TipoListas', params: { idnegocio: negocio.tag }}"> <v-icon>fas fa-tablet</v-icon></router-link>
                 </v-list-item-action>
                 <v-list-item-content>
                   <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'TipoListas', params: { idnegocio: negocio.tag }}">Tipos de Lista</router-link></v-list-item-title>
                 </v-list-item-content>
               </v-list-item>
              <v-list-item v-if="negocio.tipoNegocio.id ===2" >
                <v-list-item-action>
                  <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'TipoCarnets', params: { idnegocio: negocio.tag }}"> <v-icon>fas fa-id-card</v-icon></router-link>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'TipoCarnets', params: { idnegocio: negocio.tag }}">Tipos de Carnet</router-link></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
                 <v-list-item v-if="negocio.tipoNegocio.id ==2" >
                     <v-list-item-action>
                         <router-link color="white"  style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Temporadas', params: { idnegocio: negocio.tag }}"> <v-icon>fas fa-temperature-high</v-icon></router-link>
                     </v-list-item-action>
                     <v-list-item-content>
                         <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Temporadas', params: { idnegocio: negocio.tag }}">{{ $t('menu.temporadas') }}</router-link></v-list-item-title>
                     </v-list-item-content>
                 </v-list-item>
               <v-list-item >
                 <v-list-item-action>
                   <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Configuracion', params: { idnegocio: negocio.tag }}"> <v-icon>fas fa-tools</v-icon></router-link>
                 </v-list-item-action>
                 <v-list-item-content>
                   <v-list-item-title style="font-size:12px"><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Configuracion', params: { idnegocio: negocio.tag }}">{{ $t('menu.configuracion') }}</router-link></v-list-item-title>
                 </v-list-item-content>
               </v-list-item>
             </v-list-group>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      clipped-left
      color="#2f363e"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link :to="{ name: 'homepage'}">
        <v-img
          alt="Tunay Logo"
          class="shrink mt-1 "
          contain
          min-width="100"
          src="@/assets/tunaywhitelogo.png"
          width="100"
        />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
  <!--    <v-btn
          v-for="link in links"
          :key="link.url"
          color="white"
          text
          :href="link.href"
          rounded
          class="my-2 hidden-sm-only hidden-xs-only"
      >
        {{ link.url }}
      </v-btn>
-->
      <loginbox :paises="paises" :browser="browser" :abreviado="abreviado" :ttnegocios="ttnegocios"  :tpromotor="tpromotor" :tsuperadmin="tsuperadmin" :tsocio="tsocio" />

    </v-app-bar>
</v-app>
</template>
<script>
import { mapGetters } from "vuex";
import loginbox from '../modals/loginbox';
import axios from "axios";
import store from "@/store";
import tipoentrjson from "@/assets/json/tipoentradas.json";
import tipopagjson from "@/assets/json/tipopagos.json";
import tipoevenjson from "@/assets/json/tipoeventos.json";
import tipomembrjson from "@/assets/json/tipomembresias.json";
import sexosjson from "@/assets/json/sexos.json";
import estadocarjson from "@/assets/json/estadocarnet.json";
import diasjson from "@/assets/json/dias.json";
import firebase from 'firebase/compat/app';

  export default {
    name: 'leftmenu',
    components: {
      loginbox
    },
    props:{
      abreviado:{
        type: String
      }
    },
    data: () => ({
      drawer: null,
      mnegocios : [],
      paises:[],
      ttnegocios:false,
      tpromotor:false,
      tsocio:false,
      browser:false,
      tsuperadmin: false,
      tokencaptcha:''
  }),
  mounted(){
    this.armamenu();
    this.ttnegocios = this.$store.state.tnegocios
    this.overlayLogin = true
    this.getPaises();
    this.fnBrowserDetect();
    if(this.usuario.id === undefined){
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.tpromotor = this.usuario.promotor
              this.tsocio = this.usuario.socio
              this.tsuperadmin = this.usuario.superAdmin

              this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.recaptcha(user)
              this.overlayLogin = false
            }else{
              this.overlayLogin = false
            }
          })
    }else{
      this.tpromotor = this.usuario.promotor
      this.tsocio = this.usuario.socio
      this.tsuperadmin = this.usuario.superAdmin

      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.desconectado = false
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      this.negociospromotor = this.pnegocios
      store.dispatch("conectarse")
      this.overlayLogin = false

    }
  },
    watch: {
      '$store.state.negocios': function() {
          this.armamenu()
      }
    },
  methods: {
    armamenu(){

    this.mnegocios = this.negocios.filter(function (el){
      return el.activo === true;
    })
      this.mnegocios = this.uniqBy(this.mnegocios,it => it.id)

    },
    getPaises(){
      axios.get("paises/activos",{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response=>{
            this.paises = response.data
          })
    },
    fnBrowserDetect(){

      let userAgent = navigator.userAgent;

      if(userAgent.match(/chrome|chromium|crios/i)){
        this.rese = "chrome";
        this.browser = true;
      }else if(userAgent.match(/firefox|fxios/i)){
        this.rese = "firefox";
        this.browser = true;
      }  else if(userAgent.match(/safari/i)){
        this.rese = "safari";
        this.browser = true;
      }else if(userAgent.match(/opr\//i)){
        this.rese = "opera";
        this.browser = true;
      } else if(userAgent.match(/edg/i)){
        this.rese = "edge";
        this.browser = true;
      }else{
        this.rese="No browser detection";
        this.browser = false;
      }

    },
    async recaptcha(user) {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      this.tokencaptcha = await this.$recaptcha('login')
      // Do stuff with the received token.
      if(this.tokencaptcha !=='' ){
        this.logeo(user)
      }

    },
    logeo(user){
      var bodyFormData = new FormData();
      bodyFormData.append('uuid', user.uid);
      bodyFormData.append('token', this.tokencaptcha);


      this.overlayLogin = true
      axios.post("personas/loginbyuid",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            store.dispatch("fetchUsuario", response.data.persona);

            if(response.data.usuarionegocio!==null){
              store.dispatch("fetchNegocios", response.data.usuarionegocio);
              store.dispatch("connegocios")
              localStorage.negocios = true
              this.ttnegocios = true
            }else{
              store.dispatch("sinnegocios")
              this.ttnegocios = false
              localStorage.negocios = false
            }
            if(response.data.clientes!==null){
              store.dispatch("fetchClientes", response.data.clientes);
              store.dispatch("fetchCliente", response.data.clientes[0]);
              this.teventos = true
              localStorage.eventos = true

            }else{
              store.dispatch("fetchCliente", response.data.usuarionegocio.negocio[0].cliente);
              this.teventos = false
              localStorage.eventos = false
            }
            this.tsuperadmin = response.data.persona.superAdmin

            store.dispatch("fetchTipoEntradas", tipoentrjson);
            store.dispatch("fetchTipoPagos", tipopagjson);
            store.dispatch("fetchTipoEventos", tipoevenjson);
            store.dispatch("fetchTipoMembresias", tipomembrjson);
            store.dispatch("fetchSexos", sexosjson);
            store.dispatch("fetchEstadoCarnets", estadocarjson);
            store.dispatch("fetchDias", diasjson);
            store.dispatch("conectarse");
            this.desconectado = false;
            this.overlayLogin = false;
            this.dialog=false;
            this.tpromotor = response.data.persona.promotor
            this.abreviado =  response.data.persona.nombre + " " +  response.data.persona.apellidoPaterno;
          })
          .catch(error => {
            this.overlayLogin = false;
            console.log(error);
          });
    },
    uniqBy(a, key) {
      return [
        ...new Map(
            a.map(x => [key(x), x])
        ).values()
      ]
  }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
  }
</script>
